export default __webpack_public_path__ + "static/media/area-39.63bb6e39.jpg";